"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fromJSON = fromJSON;
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var _User = _interopRequireDefault(require("./User"));

var WorkspaceAudit =
/*#__PURE__*/
function (_Record) {
  (0, _inherits2.default)(WorkspaceAudit, _Record);

  function WorkspaceAudit() {
    (0, _classCallCheck2.default)(this, WorkspaceAudit);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(WorkspaceAudit).apply(this, arguments));
  }

  return WorkspaceAudit;
}((0, _immutable.Record)({
  actionAt: undefined,
  user: new _User.default()
}, 'WorkspaceAudit'));

function fromJSReviver(key, value) {
  if (key === 'user') {
    return new _User.default(value);
  }

  var isIndexed = _immutable.Iterable.isIndexed(value);

  return isIndexed ? value.toSet() : value.toMap();
}

function fromJSON(obj) {
  return new WorkspaceAudit((0, _immutable.fromJS)(obj, fromJSReviver));
}

var _default = WorkspaceAudit;
exports.default = _default;